import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { VinculoRoutingModule } from './vinculo-routing.module';
import { VinculoListComponent } from './pages/vinculo-list/vinculo-list.component';
import { VinculoFormComponent } from './pages/vinculo-form/vinculo-form.component';
import { DadosBasicoVinculoFormComponent } from './components/dados-basico-vinculo-form/dados-basico-vinculo-form.component';
import { VinculoSharedDataService } from './vinculo-shared-data.service';
import { DocumentoModule } from '@modules/documento/documento.module';
import { ContatoModule } from '@modules/contato/contato.module';
import { VinculoTabelaComponent } from './components/vinculo-tabela/vinculo-tabela.component';
import { ContatoVinculoFormComponent } from './components/contato-vinculo-form/contato-vinculo-form.component';
import { ContatoVinculoListComponent } from './components/contato-vinculo-list/contato-vinculo-list.component';
import { GrupoVinculoComponent } from './components/grupo-vinculo/grupo-vinculo.component';
import { DocumentoVinculoFormComponent } from './components/documento-vinculo-form/documento-vinculo-form.component';
import { DocumentoVinculoListComponent } from './components/documento-vinculo-list/documento-vinculo-list.component';
import { OutrosContatosVinculoFormComponent } from './components/outros-contatos-vinculo-form/outros-contatos-vinculo-form.component';
import { OutrosContatosVinculoListComponent } from './components/outros-contatos-vinculo-list/outros-contatos-vinculo-list.component';
import { JustificativaVinculoModalComponent } from './components/justificativa-vinculo-modal/justificativa-vinculo-modal.component';
import {AtualizacaoContatoVinculoModalComponent} from './components/atualizacao-contato-vinculo-modal/atualizacao-contato-vinculo-modal.component';
import {VinculosRepresentadosModalComponent} from './components/vinculos-representados-modal/vinculos-representados-modal.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { PessoaVinculadaInfoComponent } from './components/pessoa-vinculada-info/pessoa-vinculada-info.component';

@NgModule({
  declarations: [
    VinculoFormComponent,
    VinculoListComponent,
    DadosBasicoVinculoFormComponent,
    VinculoTabelaComponent,
    ContatoVinculoFormComponent,
    ContatoVinculoListComponent,
    GrupoVinculoComponent,
    DocumentoVinculoFormComponent,
    DocumentoVinculoListComponent,
    OutrosContatosVinculoFormComponent,
    OutrosContatosVinculoListComponent,
    JustificativaVinculoModalComponent,
    AtualizacaoContatoVinculoModalComponent,
    VinculosRepresentadosModalComponent,
    PessoaVinculadaInfoComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    VinculoRoutingModule,
    NgxPermissionsModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe,
    DocumentoModule,
    ContatoModule,
    NzToolTipModule
  ],
  exports: [
    VinculoFormComponent,
    VinculoListComponent,
    DadosBasicoVinculoFormComponent,
    VinculoTabelaComponent,
    ContatoVinculoFormComponent,
    ContatoVinculoListComponent,
    GrupoVinculoComponent,
  ],
  providers:[
    VinculoSharedDataService
  ]
})
export class VinculoModule { }
